<template>
	<section>
		<!-- Componentes externos -->
    <crear-actualizar-puestos />
    <h3 class="primary--text"><v-icon color="primary">business</v-icon> Puestos</h3>
        <!-- Boton filtro -->
        <v-tooltip bottom>
      <v-btn
        @click.native="
          () => {
            filterShow = filterShow ? false : true;
          }
        "
        class="btn-refresh"
        slot="activator"
        ><v-icon>filter_list</v-icon>
      </v-btn>
      <span>Búsqueda/filtros</span>
    </v-tooltip>
    <!-- Boton actualizar -->
    <v-tooltip bottom>
      <v-btn
        @click="listarPuestos()"
        class="btn-refresh"
        slot="activator"
        ><v-icon>refresh</v-icon>
      </v-btn>
      <span>{{ $t("common.updateList") }}</span>
    </v-tooltip>
    <v-flex xs12>
      <transition name="slide-fade">
        <div class="filter-container" v-show="filterShow">
          <v-icon small color="primary">search</v-icon>

          <div class="filter-item">
            <v-text-field
              label="Puesto"
              v-model="form.denominacion"
              @input="filterDenominacion(form.denominacion)"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Estado"
              v-model="form.estado"
              @input="filterEstado(form.estado)"
            ></v-text-field>
          </div>

          <!-- botones cerrar -->
          <div class="btn-filter">
            <v-tooltip bottom>
              <v-btn icon small slot="activator" @click.native="recargar()">
                <v-icon small>refresh</v-icon>
              </v-btn>
              <span>Recargar filtros</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                icon
                slot="activator"
                @click.native="
                  () => {
                    filterShow = false;
                    recargar();
                  }
                "
              >
                <v-icon>close</v-icon>
              </v-btn>
              <span>Cerrar filtros</span>
            </v-tooltip>
          </div>
        </div>
      </transition>
    </v-flex>
    <br />
    <v-tooltip bottom>
      <v-btn
        color="primary"
        dark
        @click.native.stop="crearActualizarPuestos({})"
        slot="activator"
        ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
      >
      <span>nuevo</span>
    </v-tooltip>
    <v-card>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="puestos"
          class="elevation-1"
          :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
          :disable-initial-sort="true"
          :loading="loading"
          no-results-text="No se encontraron coincidencias"
          item-key="id_puesto"
          :search="filters"
          :custom-filter="customFilter"
          :rows-per-page-items="[20, 40, { text: 'Todos', value: -1 }]"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
                color="primary"
                dark
                @click.native.stop="crearActualizarPuestos({})"
                slot="activator"
                ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
              >
              <span>Agregar puesto</span>
            </v-tooltip>
          </template>

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->
          
          
            <td class="text-xs-center">{{ items.item.denominacion }}</td>
            <td class="text-xs-center">{{ items.item.estado }}</td>
            <td class="nowrap text-xs-center">
              <v-tooltip bottom>
                <v-btn
                
                  icon
                  color="rgb(87,51,204)"
                  dark
                  slot="activator"
                  @click.native="crearActualizarPuestos(items.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
             
                  icon
                  color="rgb(217,38,38)"
                  dark
                  slot="activator"
                  @click.native="eliminarPuesto(items.item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            
           
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
	</section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue'; // Componente Tabla Dinámica
import crud from '@/common/util/crud-table/mixins/crud-table'; // Funciones y Metodos
import CrearActualizarPuestos from './dialogs/CrearActualizarPuestos' // Componente de creación y actualización
import Filtros from "./mixins/filtrosPuestos";

export default {
	// Importación de métodos y funciones de un archivo mixin 
	mixins: [crud,Filtros,],
	// Variables iniciales del componente
	data () {
		return {
			url: 'puestos',
      puestos:[],
			graphql: true,
      loading: false,
      form: {},
      // Variables filtros
      filters: {
        denominacion: "",
        estado: "",
      },
      filterShow: true,
			// Cabecera de la tabla
			headers: [
         { text: 'Puesto', value: 'denominacion', align: 'center' },
         { text: 'Estado', value: 'estado', align: 'center' },
        { text: this.$t('common.actions'), sortable: false, align: 'center' }
      ],
			// Campos solicitados de Graphql(Agregar los que necesite)
			dataGraphql: `
        id
        id_estado

        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
			// Filtros del componente CrudTable ejemplo:
			// {
			// 	field: 'Campo definido en Graphql',
			// 	label: 'Etiqueta del input generado',
			// 	type: 'text', // Tipo de input en el filtro
			// 	typeG: 'String' // Tipo definido en Graphql
			// }
		
		}
	},
	// Funcionalidades que se ejecutan al montar el componente
  async mounted () { 
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0] // ID's de roles permitidos
  await this.listarPuestos();
  this.$bus.$on("closeDialogCrearActualizarPuestos", async () => {
      await this.listarPuestos();
    });
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push('/403')
    }

    this.$bus.$on('closeDialog', () => {
      this.updateList()
    })
  },
	// Métodos y funciones del componente
	methods: {
    //listar puestos
    async listarPuestos(){
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
            runQuery(consulta:"select * from movilidad.v_puesto vp where vp.id_estado<>2 order by vp.id_puesto desc"){
            respuesta
            }
            } 

 `,
        });
        respuesta = respuesta.runQuery.respuesta;
        this.puestos = respuesta;
      } catch (error) {
        console.log(error)
      }
    },
    async eliminarPuesto(item){
      try {
        this.$confirm("¿Desea eliminar el registro?",async () => {
          let user = this.$storage.get("user");
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select movilidad.fn_elimina_puesto(${parseInt(item.id_puesto)},${parseInt(user.id)})"){
                  respuesta
                }
              }
            `
          });
          respuesta = respuesta.runQuery.respuesta[0].fn_elimina_puesto.split("|");
          if (respuesta[0] == "1") {
            this.$message.success("Registro eliminado exitosamente");
            await this.listarPuestos()
          } else {
            this.$message.warning(respuesta[1]);
            await this.listarPuestos()
          }
         
        });

      } catch (error) {
        console.log(error)
      }
     
    },
		crearActualizarPuestos (item) {
			this.$bus.$emit('openDialogCrearActualizarPuestos', item)
		}
	},
	// Definición de componentes importados
	components: {
		CrudTable,
		CrearActualizarPuestos
	}
}
</script>

<style lang="scss">
$filterBackground: #e1f5f0;
$filterBorder: #e5e5e5;
#cabecera_tabla {
  background: #007dbb;
  font-weight: bold;
  color: white;
}
.filter-container {
  background-color: $filterBackground;
  padding: 10px 15px 20px;
  border: 1px solid $filterBorder;
  position: relative;
  .filter-item {
    display: inline-block;
    margin-right: 15px;
    vertical-align: top;
    padding: 0em 0em 0em 0em;
    margin: 0em 0em 0em 0em;
    .v-text-field {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
    }
  }
  & > .btn-filter {
    position: absolute;
    top: -8px;
    right: 0px;
  }
  & > .v-icon {
    display: inline-block;
    margin: 14px 5px 0 0;
  }
}
.style-1 {
  background-color: rgb(191, 255, 139);
}
#style-2 {
  background: #025a66e8;
  color: white;
}
#celda_especial {
  background: rgba(233, 252, 191, 0.822);
}
#celda_especial2 {
  background: rgba(202, 243, 243, 0.767);
}
#celda {
  background: rgba(158, 205, 241, 0.5);
}
#celda_roja {
  background: rgba(190, 9, 36, 0.3);
}
.filtrosActivoFijo {
  min-width: 100%;
  padding: 0em 0.5em 0em 0.5em;
}
.sinMargen {
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/item_cargo_y_puesto/Puestos.vue